export const conditionalRowStyles = [
    {
        when: row => row.imported,
        style: {
            backgroundColor: '#D1E2C4'
        },
    },
]